import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  titleKey: string;
  hintKey: string;
}

/**
 * Пустой экран говорит, что делать дальше, а не констатирует отсутствие данных
 * (docs/PRODUCT.md, раздел 5).
 */
export function EmptyState({ titleKey, hintKey }: EmptyStateProps) {
  const { t } = useTranslation();
  return (
    <div className="max-w-prose rounded-card border border-line bg-surface px-6 py-10">
      <p className="font-serif text-lg font-semibold">{t(titleKey)}</p>
      <p className="mt-2 text-sm text-ink-2">{t(hintKey)}</p>
    </div>
  );
}
